export default __webpack_public_path__ + "static/victor-ae2dd4d17e67cc8cc2096878b443ccc8.png";